module.exports = __webpack_public_path__ + "static/media/menu-button.06ffc9ad.svg";